import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";

import { api } from "./pureFunctions";

import filterIcon from "./img/filter.webp";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from "date-fns/locale/de";
import { Einkaufer, localCache } from "./globalVariables";
import { parseOODate } from "./pureFunctions";
import { useAuth } from "./AuthContext";
import { useConfig } from "./ConfigContext";
import { goToOOAddress } from "./networkFunctions";
registerLocale("de", de);

const myColumns = {
   KdNr: "KdNr",
   Name: "Name",
   Vorname: "Vorname",
   ind_3094_Feld_adressen99: "Zuständigkeit",
   ind_3064_Feld_adressen86: "Leadart",
   ind_3070_Feld_adressen88: "Veranstaltungsdatum",
   ind_3072_Feld_adressen90: "Gutschein-Prio",
   ind_2576_Feld_adressen73: "Akquisestufe",
   Letzte_Aktion: "Letzte Aktion",
   ind_2928_Feld_adressen82: "Letzter Anruf",
   ind_3080_Feld_adressen93: "Anrufanzahl",
   ind_2582_Feld_adressen73: "Rückfragedatum",
   Benutzer: "Betreuer",
   ind_2586_Feld_adressen78: "Wunschzeitraum Anruf",
};
const myFilterColumns = {
   ind_3072_Feld_adressen90: [] /* Gutscheinprio */,
   ind_3094_Feld_adressen99: [] /* Zuständigkeit */,
   ind_2576_Feld_adressen73: [] /* Akquisestufe */,
   ind_3064_Feld_adressen86: [] /* Leadart */,
   Benutzer: [],
   ind_3072_Feld_adressen90Not: [] /* Gutscheinprio */,
   ind_3094_Feld_adressen99Not: [] /* Zuständigkeit */,
   ind_2576_Feld_adressen73Not: [] /* Akquisestufe */,
   ind_3064_Feld_adressen86Not: [] /* Leadart */,
   BenutzerNot: [],
};

const myNotFilterColumns = {
   ind_3072_Feld_adressen90: [] /* Gutscheinprio */,
   ind_3094_Feld_adressen99: [] /* Zuständigkeit */,
   ind_2576_Feld_adressen73: [] /* Akquisestufe */,
   ind_3064_Feld_adressen86: [] /* Leadart */,
   Benutzer: [],
};

let initialAddressParameters = {
   data: [
      "KdNr",
      "ind_3082_Feld_adressen94", //Personenanzahl
      "ind_3070_Feld_adressen88", //Veranstaltungsdatum,
      "ind_3084_Feld_adressen95", //Leadverlauf
      "Name",
      "Vorname",
      "Benutzer",
      "ind_3064_Feld_adressen86", //Leadart
      "ind_3072_Feld_adressen90", //Gutscheinprio
      "ind_2588_Feld_adressen76", //ist Akquisekontakt
      "ind_3094_Feld_adressen99", //zuständigkeit
      "ind_2576_Feld_adressen73", //Akquisestufe
      "Letzte_Aktion",
      "ind_2928_Feld_adressen82", //letzter Anruf
      "ind_3080_Feld_adressen93", //Anrufanzahl
      "ind_2586_Feld_adressen78", //Wunschzeitraum
      "ind_2582_Feld_adressen73", //"Rückfragedatum",
   ],
   filter: {
      ind_2588_Feld_adressen76: [{ op: "=", val: 1 }],
   },
   listlimit: 500,
   sortby: "KdNr",
   sortorder: "DESC",
};

export default function AkquiseAdressUebersicht(
   {
      /* user */
   },
) {
   const config = useConfig();
   const cConfig = config.akquiseAdressUebersicht;
   const { user, loading } = useAuth();
   const [visitors, setVisitors] = useState([]);
   const [fieldConfiguration, setFieldConfiguration] = useState();
   const [clickedRows, setClickedRows] = useState({});
   const [sortByOne, setSortByOne] = useState({});
   const [sortByTwo, setSortByTwo] = useState({});
   const [showNotEsk, setShowNotEsk] = useState(false);
   const [openFilter, setOpenFilter] = useState();
   const [showSelectedFilter, setShowSelectedFilter] = useState(false);
   const [addressFilter, setAddressFilter] = useState(() => {
      const oldFilter = localStorage.getItem(localCache.akquiseListe);
      return oldFilter ? JSON.parse(oldFilter) : { ...myFilterColumns, Benutzer: user && user.Name ? [user.Name] : [] };
   });
   const [fullLoaded, setFullLoaded] = useState(false);

   function getVisitors() {
      console.log(user.Name);

      let addressParameters = structuredClone(initialAddressParameters);

      if (addressFilter.Benutzer && addressFilter.Benutzer.length) {
         addressParameters.filter["Benutzer"] = [{ op: "IN", val: addressFilter.Benutzer }];
      }
      if (addressFilter?.[config.address.akquisestufe].length) {
         addressParameters.filter[config.address.akquisestufe] = [
            { op: "IN", val: addressFilter[config.address.akquisestufe] },
         ];
      }
      if (addressFilter.ind_3072_Feld_adressen90 && addressFilter.ind_3072_Feld_adressen90.length) {
         addressParameters.filter["ind_3072_Feld_adressen90"] = [
            { op: "IN", val: addressFilter.ind_3072_Feld_adressen90 },
         ];
      }
      if (addressFilter.ind_3094_Feld_adressen99 && addressFilter.ind_3094_Feld_adressen99.length) {
         addressParameters.filter["ind_3094_Feld_adressen99"] = [
            { op: "IN", val: addressFilter.ind_3094_Feld_adressen99 },
         ];
      }
      if (addressFilter.ind_3064_Feld_adressen86 && addressFilter.ind_3064_Feld_adressen86.length) {
         addressParameters.filter["ind_3064_Feld_adressen86"] = [
            { op: "IN", val: addressFilter.ind_3064_Feld_adressen86 },
         ];
      }

      if (addressFilter.BenutzerNot.length) {
         addressParameters.filter["Benutzer"] = addressParameters.filter["Benutzer"]
            ? [...addressParameters.filter["Benutzer"], { op: "NOT IN", val: addressFilter.BenutzerNot }]
            : [{ op: "NOT IN", val: addressFilter.BenutzerNot }];
      }

      if (addressFilter?.ind_2576_Feld_adressen73Not?.length) {
         addressParameters.filter[config.address.akquisestufe] = addressParameters.filter[config.address.akquisestufe]
            ? [
                 ...addressParameters.filter[config.address.akquisestufe],
                 { op: "NOT IN", val: addressFilter.ind_2576_Feld_adressen73Not },
              ]
            : [{ op: "NOT IN", val: addressFilter.ind_2576_Feld_adressen73Not }];
      }

      if (addressFilter.ind_3072_Feld_adressen90Not && addressFilter.ind_3072_Feld_adressen90Not.length) {
         addressParameters.filter["ind_3072_Feld_adressen90"] = addressParameters.filter["ind_3072_Feld_adressen90"]
            ? [
                 ...addressParameters.filter["ind_3072_Feld_adressen90"],
                 { op: "NOT IN", val: addressFilter.ind_3072_Feld_adressen90Not },
              ]
            : [{ op: "NOT IN", val: addressFilter.ind_3072_Feld_adressen90Not }];
      }

      if (addressFilter.ind_3094_Feld_adressen99Not && addressFilter.ind_3094_Feld_adressen99Not.length) {
         addressParameters.filter["ind_3094_Feld_adressen99"] = addressParameters.filter["ind_3094_Feld_adressen99"]
            ? [
                 ...addressParameters.filter["ind_3094_Feld_adressen99"],
                 { op: "NOT IN", val: addressFilter.ind_3094_Feld_adressen99Not },
              ]
            : [{ op: "NOT IN", val: addressFilter.ind_3094_Feld_adressen99Not }];
      }

      if (addressFilter.ind_3064_Feld_adressen86Not && addressFilter.ind_3064_Feld_adressen86Not.length) {
         addressParameters.filter["ind_3064_Feld_adressen86"] = addressParameters.filter["ind_3064_Feld_adressen86"]
            ? [
                 ...addressParameters.filter["ind_3064_Feld_adressen86"],
                 { op: "NOT IN", val: addressFilter.ind_3064_Feld_adressen86Not },
              ]
            : [{ op: "NOT IN", val: addressFilter.ind_3064_Feld_adressen86Not }];
      }

      console.log(addressParameters);

      api.post("/api/getfilteredaddresses", { parameters: addressParameters }).then((data) => {
         console.log(data);

         const visitordata = data.data.map((item, index) => {
            return {
               ...item["elements"],
               index: index,
            };
         });

         setVisitors(visitordata);
         if (visitordata.length < 500) {
            setFullLoaded(true);
         }

         api.post("/api/getFieldConfiguration", {
            fieldList: [
               "ind_3094_Feld_adressen99",
               "ind_3072_Feld_adressen90",
               config.address.akquisestufe,
               "ind_3064_Feld_adressen86",
            ],
            modules: ["address"],
         })
            .then((data) => {
               console.log(data.data);
               setFieldConfiguration(data.data[0].elements);
            })
            .catch((err) => {
               console.log(JSON.stringify(err.response.data, null, 1));
               localStorage.removeItem(localCache.build);
               return { error: JSON.stringify(err.response.data, null, 1) };
               // setErrorMessage(JSON.stringify(err.response.data, null, 1));
            });
      });
   }

   async function loadAllData() {
      let notFullyLoaded = true;
      let i = 1;

      let addressParameters = structuredClone(initialAddressParameters);
      do {
         addressParameters.listoffset = 500 * i;

         if (addressFilter.Benutzer.length) {
            addressParameters.filter["Benutzer"] = [{ op: "IN", val: addressFilter.Benutzer }];
         }
         if (addressFilter?.[config.address.akquisestufe]?.length) {
            addressParameters.filter[config.address.akquisestufe] = [
               { op: "IN", val: addressFilter[config.address.akquisestufe] },
            ];
         }
         if (addressFilter.ind_3072_Feld_adressen90.length) {
            addressParameters.filter["ind_3072_Feld_adressen90"] = [
               { op: "IN", val: addressFilter.ind_3072_Feld_adressen90 },
            ];
         }
         if (addressFilter.ind_3094_Feld_adressen99.length) {
            addressParameters.filter["ind_3094_Feld_adressen99"] = [
               { op: "IN", val: addressFilter.ind_3094_Feld_adressen99 },
            ];
         }
         if (addressFilter.ind_3064_Feld_adressen86.length) {
            addressParameters.filter["ind_3064_Feld_adressen86"] = [
               { op: "IN", val: addressFilter.ind_3064_Feld_adressen86 },
            ];
         }

         await api
            .post("/api/getfilteredaddresses", { parameters: addressParameters })
            .then((data) => {
               console.log(data);

               const visitordata = data.data.map((item, index) => {
                  return {
                     ...item["elements"],
                     index: index,
                  };
               });
               console.log(data.data.length);
               if (data.data.length < 500) {
                  notFullyLoaded = false;
               }

               setVisitors((prev) => [...prev, ...visitordata]);
               i++;
            })
            .catch((err) => {
               console.log(err);
               i = 500;
            });
      } while (notFullyLoaded);

      setFullLoaded(true);
   }

   async function goToOnOffice(myAddressId) {
      await goToOOAddress(myAddressId);
      setClickedRows((prev) => ({ ...prev, [myAddressId]: true }));
   }

   useEffect(() => {
      getVisitors();
   }, []);

   function changeFilter(e, column, item) {
      e.stopPropagation();
      console.log(addressFilter);
      const newFilter = structuredClone(addressFilter);
      (newFilter[column] = newFilter[column].includes(item)
         ? newFilter[column].filter((item2) => item2 != item)
         : [...newFilter[column], item]),
         console.log(newFilter);

      setAddressFilter(newFilter);

      setFullLoaded(true);

      localStorage.setItem(localCache.akquiseListe, JSON.stringify(newFilter));
   }
   function sortRows(myParameter) {
      let sortBool = 1;
      let mySorter = structuredClone(sortByOne);

      if (mySorter) {
         if (mySorter[myParameter] != undefined) {
            mySorter[myParameter] *= -1;
         } else mySorter = { [myParameter]: 1 };
      } else {
         mySorter = { [myParameter]: 1 };
      }

      if (myParameter === config.address.akquisestufe && fieldConfiguration) {
         setVisitors((prev) => {
            return prev.sort((a, b) => {
               if (
                  fieldConfiguration[myParameter].permittedvalues[a[myParameter]] >
                  fieldConfiguration[myParameter].permittedvalues[b[myParameter]]
               )
                  return mySorter[myParameter];
               else if (
                  fieldConfiguration[myParameter].permittedvalues[a[myParameter]] <
                  fieldConfiguration[myParameter].permittedvalues[b[myParameter]]
               )
                  return -1 * mySorter[myParameter];
               else return 0;
            });
         });
      } else {
         setVisitors((prev) => {
            return prev.sort((a, b) => {
               if (a[myParameter] > b[myParameter]) return mySorter[myParameter];
               else if (a[myParameter] < b[myParameter]) return -1 * mySorter[myParameter];
               else if (b[myParameter]) return -1 * mySorter[myParameter];
               else if (a[myParameter]) return 1 * mySorter[myParameter];
               else return 0;
            });
         });
      }
      setSortByOne(mySorter);
   }

   return (
      <>
         <div className="m-4 mt-4">
            <title>{"AK "}</title>
            <h2 className="text-center">
               Akquiseliste{" "}
               <strong className="me-2">
                  ({visitors.length}
                  {visitors.length === 500 ? "+" : ""} Stück insgesamt)
               </strong>
               <small>
                  {
                     visitors.filter((visitor) => {
                        let abgelaufen = true;

                        //If abgeschlossen oder if rückfragedatum nicht abgelaufen
                        if (Object.keys(cConfig.abgeschlosseneAkquise).includes(visitor[config.address.akquisestufe])) {
                           abgelaufen = false;
                        } else if (
                           visitor[config.address.rueckfrageDatum] &&
                           visitor[config.address.rueckfrageDatum] != "0000-00-00"
                        ) {
                           if (new Date(visitor[config.address.rueckfrageDatum]) > new Date()) {
                              abgelaufen = false;
                           }
                        }
                        return abgelaufen;
                     }).length
                  }{" "}
                  eskalieren
               </small>
               <Button
                  variant="primary"
                  className="ms-4"
                  onClick={() => {
                     getVisitors();
                     setSortByOne("");
                     setFullLoaded(false);
                  }}
               >
                  aktualisieren
               </Button>
               {!fullLoaded && (
                  <Button
                     variant="dark"
                     className="mx-1"
                     onClick={() => {
                        loadAllData();
                     }}
                  >
                     alle Daten laden
                  </Button>
               )}
            </h2>

            <div className="flex-row">
               <Button
                  variant="dark"
                  className="me-1"
                  onClick={() => {
                     const myfilterColumn = {
                        ind_3072_Feld_adressen90: [] /* Gutscheinprio */,
                        ind_3094_Feld_adressen99: [] /* Zuständigkeit */,
                        [config.address.akquisestufe]: ["ind_Schl_4547"] /* Akquisestufe */,
                        ind_3064_Feld_adressen86: [] /* Leadart */,
                        Benutzer: user && user.Name ? [user.Name] : [],
                        ind_3072_Feld_adressen90Not: [] /* Gutscheinprio */,
                        ind_3094_Feld_adressen99Not: [] /* Zuständigkeit */,
                        ind_2576_Feld_adressen73Not: [] /* Akquisestufe */,
                        ind_3064_Feld_adressen86Not: [] /* Leadart */,
                        BenutzerNot: [],
                     };
                     setAddressFilter(myfilterColumn);
                  }}
               >
                  Meine Nicht Begonnenen
               </Button>
               <Button
                  variant="dark"
                  className="me-1"
                  onClick={() => {
                     const myfilterColumn = {
                        ind_3072_Feld_adressen90: [] /* Gutscheinprio */,
                        ind_3094_Feld_adressen99: [] /* Zuständigkeit */,
                        [config.address.akquisestufe]: [
                           "ind_Schl_4723",
                           "ind_Schl_4725",
                           "ind_Schl_4541",
                           "ind_Schl_4547",
                           "ind_Schl_4545",
                           "ind_Schl_4893",
                           "ind_Schl_4543",
                           "ind_Schl_4867",
                        ] /* Akquisestufe */,
                        ind_3064_Feld_adressen86: ["ind_Schl_4857"] /* Leadart */,
                        Benutzer: user && user.Name ? [user.Name] : [],
                        ind_3072_Feld_adressen90Not: [] /* Gutscheinprio */,
                        ind_3094_Feld_adressen99Not: [] /* Zuständigkeit */,
                        ind_2576_Feld_adressen73Not: [] /* Akquisestufe */,
                        ind_3064_Feld_adressen86Not: [] /* Leadart */,
                        BenutzerNot: [],
                     };
                     setAddressFilter(myfilterColumn);
                  }}
               >
                  Meine VA
               </Button>
               <Button
                  variant="dark"
                  className="me-2"
                  onClick={() => {
                     const myfilterColumn = {
                        ind_3072_Feld_adressen90: [
                           "ind_Schl_4863",
                           "ind_Schl_4861",
                           "ind_Schl_4859",
                        ] /* Gutscheinprio */,
                        ind_3094_Feld_adressen99: [] /* Zuständigkeit */,
                        [config.address.akquisestufe]: [
                           "ind_Schl_4723",
                           "ind_Schl_4725",
                           "ind_Schl_4541",
                           "ind_Schl_4547",
                           "ind_Schl_4545",
                           "ind_Schl_4893",
                           "ind_Schl_4543",
                           "ind_Schl_4867",
                        ] /* Akquisestufe */,
                        ind_3064_Feld_adressen86: [] /* Leadart */,
                        Benutzer: user && user.Name ? [user.Name] : [],
                        ind_3072_Feld_adressen90Not: [] /* Gutscheinprio */,
                        ind_3094_Feld_adressen99Not: [] /* Zuständigkeit */,
                        ind_2576_Feld_adressen73Not: [] /* Akquisestufe */,
                        ind_3064_Feld_adressen86Not: [] /* Leadart */,
                        BenutzerNot: [],
                     };
                     setAddressFilter(myfilterColumn);
                  }}
               >
                  Meine VA (Prio)
               </Button>
               <Button
                  variant="dark"
                  className="me-2"
                  onClick={() => {
                     const myfilterColumn = {
                        ind_3072_Feld_adressen90: [] /* Gutscheinprio */,
                        ind_3094_Feld_adressen99: [] /* Zuständigkeit */,
                        [config.address.akquisestufe]: [
                           "ind_Schl_4723",
                           "ind_Schl_4725",
                           "ind_Schl_4541",
                           "ind_Schl_4547",
                           "ind_Schl_4545",
                           "ind_Schl_4893",
                           "ind_Schl_4543",
                           "ind_Schl_4867",
                        ] /* Akquisestufe */,
                        ind_3064_Feld_adressen86: [] /* Leadart */,
                        Benutzer: user && user.Name ? [user.Name] : [],
                        ind_3072_Feld_adressen90Not: [] /* Gutscheinprio */,
                        ind_3094_Feld_adressen99Not: [] /* Zuständigkeit */,
                        ind_2576_Feld_adressen73Not: [] /* Akquisestufe */,
                        ind_3064_Feld_adressen86Not: ["ind_Schl_4857"] /* Leadart */,
                        BenutzerNot: [],
                     };

                     setAddressFilter(myfilterColumn);
                  }}
               >
                  Meine Sonstige Leadarten
               </Button>
               <Button
                  variant={showSelectedFilter ? "primary" : "outline-primary"}
                  className="ms-3"
                  onClick={() => {
                     setShowSelectedFilter((prev) => !prev);
                  }}
               >
                  Filterkriterien {showSelectedFilter ? "ausblenden" : "anzeigen"}
               </Button>
            </div>

            {showSelectedFilter && (
               <div
                  className="flex-row"
                  style={{ padding: "8px 14px", boxShadow: "0 0 20px #0002", borderRadius: "8px" }}
               >
                  <Button
                     variant={showNotEsk ? "secondary" : "outline-secondary"}
                     className="me-3"
                     onClick={() => {
                        setShowNotEsk((prev) => !prev);
                     }}
                  >
                     nicht eskalierte {showNotEsk ? "Aus" : "Ein"}blenden
                  </Button>

                  {Object.keys(addressFilter).map((column) => {
                     let newColumnName = "";
                     if (column.includes("Not")) {
                        // console.log(column.slice(0,-3));
                        newColumnName = column.slice(0, -3);
                     }
                     if (addressFilter[column].length > 0)
                        return (
                           <div className="me-3 mb-1 flex-row">
                              <strong className="me-2">{myColumns[newColumnName ? newColumnName : column]}:</strong>
                              <div>
                                 {addressFilter[column].map((item) => {
                                    return (
                                       <Button
                                          className="m-1"
                                          variant={newColumnName ? "outline-danger" : "outline-dark"}
                                          onClick={(e) => {
                                             changeFilter(e, column, item);
                                          }}
                                       >
                                          {newColumnName ? (
                                             <span>
                                                Nicht{" "}
                                                {fieldConfiguration && fieldConfiguration[newColumnName]
                                                   ? fieldConfiguration[newColumnName].permittedvalues[item]
                                                   : item}
                                             </span>
                                          ) : (
                                             <span>
                                                {fieldConfiguration && fieldConfiguration[column]
                                                   ? fieldConfiguration[column].permittedvalues[item]
                                                   : item}
                                             </span>
                                          )}

                                          {" x"}
                                       </Button>
                                    );
                                 })}
                              </div>
                           </div>
                        );
                  })}
               </div>
            )}

            <div className="mb-2">
               <div className="immobilienuebersicht">
                  <table>
                     <thead>
                        <tr className="text-start">
                           {Object.keys(myColumns).map((column) => (
                              <th
                                 style={{
                                    paddingRight: myFilterColumns[column] ? "62px" : "",
                                    position: "relative",
                                    cursor: "pointer",
                                    ...(sortByOne[column] === 1
                                       ? { backgroundColor: "#38c", color: "#fff" }
                                       : sortByOne[column] === -1
                                         ? { backgroundColor: "#2c7", color: "#fff" }
                                         : {}),
                                 }}
                                 onClick={() => sortRows(column)}
                              >
                                 {myColumns[column]} {sortByOne[column] === -1 && "▼"}
                                 {sortByOne[column] === 1 && "▲"}
                                 {myFilterColumns[column] && (
                                    <button
                                       onClick={(e) => {
                                          e.stopPropagation();
                                          console.log(column);

                                          setOpenFilter((prev) => (prev === column ? "" : column));
                                       }}
                                       style={{
                                          position: "absolute",
                                          right: "8px",
                                          top: "5px",
                                          backgroundColor: "#fff",
                                          border: "none",
                                          boxShadow: "0 0 8px #0008",
                                          borderRadius: "6px",
                                       }}
                                    >
                                       <img src={filterIcon} height={30} />
                                    </button>
                                 )}
                                 {openFilter === column && (
                                    <div
                                       onMouseLeave={() => {
                                          setOpenFilter("");
                                       }}
                                       style={{
                                          top: "40px",
                                          left: "0px",
                                          position: "absolute",
                                          backgroundColor: "#fffd",
                                          padding: "20px",
                                          display: "flex",
                                          flexDirection: "column",
                                          zIndex: 10,
                                       }}
                                    >
                                       {fieldConfiguration[column] &&
                                          Object.keys(fieldConfiguration[column].permittedvalues).map((item) => {
                                             return (
                                                <Button
                                                   className="mb-1"
                                                   onClick={(e) => {
                                                      changeFilter(e, column, item);
                                                   }}
                                                   variant={addressFilter[column].includes(item) ? "dark" : "secondary"}
                                                >
                                                   {fieldConfiguration[column].permittedvalues[item]}
                                                </Button>
                                             );
                                          })}
                                       {column === "Benutzer" &&
                                          Object.keys(Einkaufer).map((item) => (
                                             <Button
                                                className="mb-1"
                                                onClick={(e) => {
                                                   changeFilter(e, column, item);
                                                }}
                                                variant={
                                                   addressFilter["Benutzer"].includes(item) ? "dark" : "secondary"
                                                }
                                             >
                                                {item}
                                             </Button>
                                          ))}
                                    </div>
                                 )}
                              </th>
                           ))}
                        </tr>
                     </thead>
                     <tbody>
                        {visitors.length > 0 &&
                           visitors.map((visitor, index) => {
                              let abgelaufen = true;

                              //If abgeschlossen oder if rückfragedatum nicht abgelaufen
                              if (
                                 Object.keys(cConfig.abgeschlosseneAkquise).includes(
                                    visitor[config.address.akquisestufe],
                                 )
                              ) {
                                 abgelaufen = false;
                              } else if (
                                 visitor[config.address.rueckfrageDatum] &&
                                 visitor[config.address.rueckfrageDatum] != "0000-00-00"
                              ) {
                                 if (new Date(visitor[config.address.rueckfrageDatum]) > new Date()) {
                                    abgelaufen = false;
                                 }
                              }
                              return (
                                 <>
                                    <tr
                                       style={{
                                          display: abgelaufen || showNotEsk ? "" : "none",
                                          backgroundColor: abgelaufen ? "#a00" : "",
                                          cursor: "pointer",
                                          opacity: clickedRows[visitor.id] ? 0.7 : 1,
                                       }}
                                       className="text-center"
                                       onClick={() => goToOnOffice(visitor.id)}
                                    >
                                       <td>{visitor.KdNr}</td>
                                       <td className="text-start">{visitor.Name}</td>
                                       <td className="text-start">{visitor.Vorname}</td>
                                       <td>
                                          {fieldConfiguration &&
                                             fieldConfiguration["ind_3094_Feld_adressen99"].permittedvalues[
                                                visitor.ind_3094_Feld_adressen99
                                             ]}
                                       </td>
                                       <td>
                                          {/* Leadart */}
                                          {fieldConfiguration &&
                                             fieldConfiguration["ind_3064_Feld_adressen86"].permittedvalues[
                                                visitor.ind_3064_Feld_adressen86
                                             ]}
                                       </td>

                                       <td>
                                          {/* Veranstaltungsdatum */}
                                          {visitor.ind_3070_Feld_adressen88}
                                       </td>
                                       <td>
                                          {/* Gutscheinprio */}
                                          {fieldConfiguration &&
                                             fieldConfiguration["ind_3072_Feld_adressen90"].permittedvalues[
                                                visitor.ind_3072_Feld_adressen90
                                             ]}
                                       </td>
                                       <td className="text-start">
                                          {fieldConfiguration &&
                                             fieldConfiguration[config.address.akquisestufe].permittedvalues[
                                                visitor[config.address.akquisestufe]
                                             ]}
                                       </td>
                                       <td>
                                          {visitor.Letzte_Aktion && new Date(visitor.Letzte_Aktion).toLocaleString()}
                                       </td>
                                       <td>{visitor.ind_2928_Feld_adressen82}</td>
                                       <td>{visitor.ind_3080_Feld_adressen93}</td>
                                       <td>{visitor[config.address.rueckfrageDatum]}</td>
                                       <td>{visitor.Benutzer}</td>

                                       <td className="text-start">{visitor.ind_2586_Feld_adressen78}</td>
                                    </tr>
                                 </>
                              );
                           })}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </>
   );
}
